export type SolutionKey = 'design' | 'ecommerce' | 'seo' | 'managed' | 'integrations' | 'redesign'

export type Solution = {
  key: SolutionKey
  label: string
  headline: string
  problem: string
  body: string
  deliverables: string[]
  accent: 'orange' | 'green' | 'cyan'
}

export const solutions: Solution[] = [
  {
    key: 'design',
    label: 'Custom web design',
    headline: 'Designed around your offers, not a theme',
    problem: 'Your site looks like every competitor in your category.',
    body: 'We design page by page around what you sell and how people buy it. Responsive from the smallest phone up, fast, accessible, and built so the layout never fights your content.',
    deliverables: ['Custom design system', 'Page templates per offer', 'Mobile-first responsive build', 'Accessibility and speed pass'],
    accent: 'orange',
  },
  {
    key: 'ecommerce',
    label: 'Ecommerce websites',
    headline: '0% transaction fees from WebsiteForge',
    problem: 'Fees, add-ons, and rigid checkouts take a cut of every order.',
    body: 'We build stores around your real pricing, options, and fulfilment. We take 0% of your transactions — your processor charges its rate and that is the end of the list.',
    deliverables: ['0% transaction fees from us', 'Complex products and options', 'Account and wholesale pricing', 'Quote-to-order paths'],
    accent: 'green',
  },
  {
    key: 'seo',
    label: 'SEO + marketing structure',
    headline: 'Structure that turns traffic into contacts',
    problem: 'You get visits, but the phone does not ring.',
    body: 'We build the service, location, and content structure search engines can read and buyers can follow, then measure it against calls, forms, quote requests, and orders.',
    deliverables: ['Service and location architecture', 'Technical SEO and page speed', 'Content plan we actually write', 'Tracking tied to real actions'],
    accent: 'cyan',
  },
  {
    key: 'managed',
    label: 'CMS, hosting & support',
    headline: 'We keep it live, current, and secure',
    problem: 'Every small edit turns into a week-long ticket somewhere else.',
    body: 'Managed hosting, SSL, backups, monitoring, and a CMS scoped to your content. Train your team on it, or send us the change and we handle it.',
    deliverables: ['Managed hosting and SSL', 'Backups and monitoring', 'Content updates on request', 'Team training and documentation'],
    accent: 'orange',
  },
  {
    key: 'integrations',
    label: 'API integrations',
    headline: 'Connected to the systems you already run',
    problem: 'Your website and your back office never talk to each other.',
    body: 'We build the API workflows between your site and your CRM, accounting, scheduling, inventory, or internal tools so information moves once instead of being retyped.',
    deliverables: ['100+ integrations delivered', 'Custom API workflows', 'Secure data handling', 'Automation for manual steps'],
    accent: 'cyan',
  },
  {
    key: 'redesign',
    label: 'Website redesigns',
    headline: 'Rebuild without losing what works',
    problem: 'The site still runs, but it is eight years old and it shows.',
    body: 'We keep the rankings, content, and history that are earning, and rebuild everything around them. Migrations are mapped, redirected, and tested before launch day.',
    deliverables: ['Content and ranking migration', 'Redirect mapping and QA', 'Phased low-risk launch', 'Modern, faster foundation'],
    accent: 'green',
  },
]
